import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import { foramtCareerDate } from '../../../../../utils/profile-page/format-career-date';
import { IEducationResponse } from '../../../../../interfaces/education.interface';
import { gridContainerStyles } from '../AboutTab';

interface TabEducationEntryProps {
  education?: Partial<IEducationResponse>;
}

const NO_DATA = 'No information';
const TabEducationEntry: FC<TabEducationEntryProps> = ({ education }) => {
  function capitalizeFirstLetter(str?: string) {
    if (!str || str.length === 0) return NO_DATA;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return (
    <Grid container rowGap="28px" sx={gridContainerStyles}>
      <Grid item display="flex" flexDirection="row">
        <Typography className="label" variant="caption">
          Education level:
        </Typography>
        <Typography className="plain-text" variant="body3">
          {education?.level ? capitalizeFirstLetter(education?.level) : NO_DATA}
        </Typography>
      </Grid>
      <Grid item display="flex" flexDirection="row">
        <Typography className="label" variant="caption">
          University:
        </Typography>
        <Typography className="plain-text" variant="body3">
          {education?.university || NO_DATA}
        </Typography>
      </Grid>
      <Grid item display="flex" flexDirection="row">
        <Typography className="label" variant="caption">
          Specialty:
        </Typography>
        <Typography className="plain-text" variant="body3">
          {education?.specialty || NO_DATA}
        </Typography>
      </Grid>
      <Grid item display="flex" flexDirection="row">
        <Typography className="label" variant="caption">
          Years:
        </Typography>
        {education?.startYear && education?.endYear ? (
          <Typography className="plain-text" variant="body3">
            {foramtCareerDate(education.startYear ?? '')} -{' '}
            {foramtCareerDate(education.endYear ?? '')}
          </Typography>
        ) : (
          <Typography className="plain-text" variant="body3">
            {NO_DATA}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default TabEducationEntry;
